import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import '../css/RankBadge.css';

const RANK_DISPLAY = {
    bronze_3:    { color: '#CD7F32', icon: 'fa-shield-alt' },
    bronze_2:    { color: '#CD7F32', icon: 'fa-shield-alt' },
    bronze_1:    { color: '#CD7F32', icon: 'fa-shield-alt' },
    silver_3:    { color: '#C0C0C0', icon: 'fa-shield-alt' },
    silver_2:    { color: '#C0C0C0', icon: 'fa-shield-alt' },
    silver_1:    { color: '#C0C0C0', icon: 'fa-shield-alt' },
    gold_3:      { color: '#FFD700', icon: 'fa-crown' },
    gold_2:      { color: '#FFD700', icon: 'fa-crown' },
    gold_1:      { color: '#FFD700', icon: 'fa-crown' },
    platinum_3:  { color: '#E5E4E2', icon: 'fa-gem' },
    platinum_2:  { color: '#E5E4E2', icon: 'fa-gem' },
    platinum_1:  { color: '#E5E4E2', icon: 'fa-gem' },
    diamond_3:   { color: '#B9F2FF', icon: 'fa-diamond' },
    diamond_2:   { color: '#B9F2FF', icon: 'fa-diamond' },
    diamond_1:   { color: '#B9F2FF', icon: 'fa-diamond' },
    master:      { color: '#FF4500', icon: 'fa-star' },
    grandmaster: { color: '#8B0000', icon: 'fa-chess-queen' },
};

// Translated tier name; unknown tiers fall back to the server's name, then to the lowest tier.
export function rankTierName(t, tier, fallback) {
    if (RANK_DISPLAY[tier]) return t(`rank.tiers.${tier}`);
    return fallback || t('rank.tiers.bronze_3');
}

function RankBadge({ tier, rating, size = 'medium', showRating = true, provisional = false }) {
    const { t } = useTranslation();
    const display = RANK_DISPLAY[tier] || RANK_DISPLAY.bronze_3;

    return (
        <div className={`rank-badge rank-badge-${size}`}>
            <i
                className={`fas ${display.icon} rank-icon`}
                style={{ color: display.color }}
            ></i>
            {size !== 'small' && (
                <span className="rank-name" style={{ color: display.color }}>
                    {rankTierName(t, tier)}
                </span>
            )}
            {showRating && (
                <span className="rank-rating">
                    {rating}{provisional ? '?' : ''}
                </span>
            )}
        </div>
    );
}

export { RANK_DISPLAY };
export default RankBadge;
